import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Config from '../helpers/config'

import IndexPage from '@/pages/index'
import TimelinePage from '@/pages/timeline'
import SwitcherPage from '@/pages/switcher'
import AlertPage from '@/pages/alert'
import IconPage from '@/pages/icon'
import LayoutPage from '@/pages/layout'
import ButtonPage from '@/pages/button'
import TagPage from '@/pages/tag'
import TabstripPage from '@/pages/tabstrip'
import RatingPage from '@/pages/rating'
import ListPage from '@/pages/list'
import LoremIpsumPage from '@/pages/lorem-ipsum'
import AvatarPage from '@/pages/avatar'
import ToolbarPage from '@/pages/toolbar'
import CollapsiblePage from '@/pages/collapsible'
import DialogPage from '@/pages/dialog'
import PageNotFound from '@/pages/404'
import ColorsPage from '@/pages/colors'
import ElevationPage from '@/pages/elevation'
import TypographyPage from '@/pages/typography'
import FooterPage from '@/pages/footer'
import ContentPage from '@/pages/content'
import ThemePage from '@/pages/theme'
import SpacingPage from '@/pages/spacing'
import TextPage from '@/pages/text'
import ChatPage from '@/pages/chat'
import CardPage from '@/pages/card'
import JumbotronPage from '@/pages/jumbotron'
import CheckboxPage from '@/pages/checkbox'
import TooltipPage from '@/pages/tooltip'
import RipplePage from '@/pages/ripple'
import SelectPage from '@/pages/select'
import QuickStartPage from '@/pages/quick-start'
import PageNavDrawer from '@/pages/nav-drawer'
import PageLoadingOverlay from '@/pages/loading-overlay'
import SearchPage from '@/pages/search'
import BrowserSupportPage from '@/pages/browser-support'
import SponsorsPage from '@/pages/sponsors'
import SupportVuecidityPage from '@/pages/support-vuecidity'
import ComingUpPage from '@/pages/coming-up'
import ButtonGroupPage from '@/pages/button-group'
import BreadcrumbsPage from '@/pages/breadcrumbs'
import ProgressPage from '@/pages/progress'
import RadioGroupPage from '@/pages/radio-group'
import SnackbarPage from '@/pages/snackbar'
import NotificationPage from '@/pages/notification'
import PagerPage from '@/pages/pager'
import ResizePage from '@/pages/resize'
import BadgePage from '@/pages/badge'
import ButtonSplitPage from '@/pages/button-split'
import CookieConsentPage from '@/pages/cookie-consent'
import CookiePolicyPage from '@/pages/cookie-policy'
import SocialBarPage from '@/pages/social-bar'
import FlagPage from '@/pages/flag'
import DownloadsPage from '@/pages/downloads'

import TopLevelComponents from '@/pages/top-level-components'
import TopLevelLayout from '@/pages/top-level-layout'
import TopLevelStyle from '@/pages/top-level-style'
import TopLevelDirectives from '@/pages/top-level-directives'
import TopLevelFormElements from '@/pages/top-level-form-elements'
import TopLevelGettingStarted from '@/pages/top-level-getting-started'

Vue.use(Router)

let routes = [{
  path: '/',
  name: 'home',
  label: 'Home',
  component: IndexPage
}, {
  path: '/page-not-found',
  name: 'page-not-found',
  component: PageNotFound
}, {
  path: '/cookie-policy',
  name: 'cookie-policy',
  component: CookiePolicyPage
}, {
  path: '/search',
  name: 'search',
  component: SearchPage
}, {
  path: '/downloads',
  name: 'downloads',
  component: DownloadsPage
}, {
  path: '*',
  redirect: '/page-not-found'
}]

const components = [{
  path: '/components',
  name: 'top-level-components',
  label: 'UI Components',
  component: TopLevelComponents,
  type: 'components',
  icon: 'mdi-view-dashboard',
  hide: true
}, {
  path: '/components/lorem-ipsum',
  name: 'lorem-ipsum',
  label: 'Lorem ipsum',
  component: LoremIpsumPage,
  type: 'components',
  icon: 'short_text'
}, {
  path: '/components/alert',
  name: 'alert',
  label: 'Alert',
  component: AlertPage,
  type: 'components',
  icon: 'assignment_late'
}, {
  path: '/components/collapsible',
  name: 'collapsible',
  label: 'Collapsible',
  component: CollapsiblePage,
  type: 'components',
  icon: 'format_line_spacing'
}, {
  path: '/components/list',
  name: 'list',
  label: 'List',
  component: ListPage,
  type: 'components',
  icon: 'view_list'
}, {
  path: '/components/timeline',
  name: 'timeline',
  label: 'Timeline',
  component: TimelinePage,
  type: 'components',
  icon: 'timelapse'
}, {
  path: '/components/icon',
  name: 'icon',
  label: 'Icon',
  component: IconPage,
  type: 'components',
  icon: 'info_outline'
}, {
  path: '/components/layout',
  name: 'layout-layout',
  label: 'Grid layout',
  component: LayoutPage,
  type: 'components',
  icon: 'web'
}, {
  path: '/components/tag',
  name: 'tag',
  label: 'Tag',
  component: TagPage,
  type: 'components',
  icon: 'loyalty'
}, {
  path: '/components/tabstrip',
  name: 'tabstrip',
  label: 'Tabstrip',
  component: TabstripPage,
  type: 'components',
  icon: 'tab'
}, {
  path: '/components/rating',
  name: 'rating',
  label: 'Rating',
  component: RatingPage,
  type: 'components',
  icon: 'star_half'
}, {
  path: '/components/avatar',
  name: 'avatar',
  label: 'Avatar',
  component: AvatarPage,
  type: 'components',
  icon: 'account_circle'
}, {
  path: '/components/toolbar',
  name: 'toolbar',
  label: 'Toolbar',
  component: ToolbarPage,
  type: 'components',
  icon: 'mdi-page-layout-header'
}, {
  path: '/components/dialog',
  name: 'dialog',
  label: 'Dialog',
  component: DialogPage,
  type: 'components',
  icon: 'question_answer'
}, {
  path: '/components/footer',
  name: 'footer',
  label: 'Footer',
  component: FooterPage,
  type: 'components',
  icon: 'mdi-page-layout-footer'
}, {
  path: '/components/chat',
  name: 'chat',
  label: 'Chat',
  component: ChatPage,
  type: 'components',
  icon: 'chat'
}, {
  path: '/components/card',
  name: 'card',
  label: 'Card',
  component: CardPage,
  type: 'components',
  icon: 'mdi-contact-mail'
}, {
  path: '/components/jumbotron',
  name: 'jumbotron',
  label: 'Jumbotron',
  component: JumbotronPage,
  type: 'components',
  icon: 'aspect_ratio'
}, {
  path: '/components/loading-overlay',
  name: 'loading-overlay',
  label: 'Loading overlay',
  component: PageLoadingOverlay,
  type: 'components',
  icon: 'hourglass_full'
}, {
  path: '/components/nav-drawer',
  name: 'nav-drawer',
  label: 'Nav drawer',
  component: PageNavDrawer,
  type: 'components',
  icon: 'view_array'
}, {
  path: '/components/button-group',
  name: 'button-group',
  label: 'Button group',
  component: ButtonGroupPage,
  type: 'components',
  icon: 'panorama_wide_angle'
}, {
  path: '/components/button',
  name: 'button',
  label: 'Button',
  component: ButtonPage,
  type: 'components',
  icon: 'panorama_wide_angle'
}, {
  path: '/components/breadcrumbs',
  name: 'breadcrumbs',
  label: 'Breadcrumbs',
  component: BreadcrumbsPage,
  type: 'components',
  icon: 'skip_next'
}, {
  path: '/components/progress',
  name: 'progress',
  label: 'Progress',
  component: ProgressPage,
  type: 'components',
  icon: 'trending_flat'
}, {
  path: '/components/snackbar',
  name: 'snackbar',
  label: 'Snackbar',
  component: SnackbarPage,
  type: 'components',
  icon: 'note'
}, {
  path: '/components/notification',
  name: 'notification',
  label: 'Notification',
  component: NotificationPage,
  type: 'components',
  icon: 'notifications'
}, {
  path: '/components/pager',
  name: 'pager',
  label: 'Pager',
  component: PagerPage,
  type: 'components',
  icon: 'mdi-page-last'
}, {
  path: '/components/badge',
  name: 'badge',
  label: 'Badge',
  component: BadgePage,
  type: 'components',
  icon: 'mdi-label-outline'
}, {
  path: '/components/button-split',
  name: 'button-split',
  label: 'Button split',
  component: ButtonSplitPage,
  type: 'components',
  icon: 'details'
}, {
  path: '/components/cookie-consent',
  name: 'cookie-consent',
  label: 'Cookie consent',
  component: CookieConsentPage,
  type: 'components',
  icon: 'mdi-cookie'
}, {
  path: '/components/social-bar',
  name: 'social-bar',
  label: 'Social bar',
  component: SocialBarPage,
  type: 'components',
  icon: 'share'
}, {
  path: '/components/flag',
  name: 'flag',
  label: 'Flag',
  component: FlagPage,
  type: 'components',
  icon: 'flag'
}]

const formElements = [{
  path: '/form-elements',
  name: 'top-level-form-elements',
  label: 'Styles and Colors',
  component: TopLevelFormElements,
  type: 'form-elements',
  icon: 'panorama_wide_angle',
  hide: true
}, {
  path: '/form-elements/select',
  name: 'select',
  label: 'Select',
  component: SelectPage,
  type: 'form-elements',
  icon: 'event_note'
}, {
  path: '/form-elements/checkbox',
  name: 'checkbox',
  label: 'Checkbox',
  component: CheckboxPage,
  type: 'form-elements',
  icon: 'check_box'
}, {
  path: '/form-elements/switcher',
  name: 'switcher',
  label: 'Switcher',
  component: SwitcherPage,
  type: 'form-elements',
  icon: 'mdi-toggle-switch'
}, {
  path: '/form-elements/text',
  name: 'text',
  label: 'Text',
  component: TextPage,
  type: 'form-elements',
  icon: 'mdi-textbox'
}, {
  path: '/form-elements/radio-group',
  name: 'radio-group',
  label: 'Radio group',
  component: RadioGroupPage,
  type: 'form-elements',
  icon: 'radio_button_checked'
}]

const style = [{
  path: '/style/colors',
  name: 'colors',
  label: 'Colors',
  type: 'style',
  component: ColorsPage,
  icon: 'mdi-format-color-fill'
}, {
  path: '/style/typography',
  name: 'typography',
  label: 'Typography',
  type: 'style',
  component: TypographyPage,
  icon: 'mdi-format-font'
}, {
  path: '/style/content',
  name: 'content',
  label: 'Content',
  type: 'style',
  component: ContentPage,
  icon: 'mdi-format-paragraph'
}, {
  path: '/style/theme',
  name: 'theme',
  label: 'Theme',
  type: 'style',
  component: ThemePage,
  icon: 'mdi-theme-light-dark'
}, {
  path: '/style',
  name: 'top-level-style',
  label: 'Styles and Colors',
  component: TopLevelStyle,
  type: 'components',
  icon: 'style',
  hide: true
}]

const layout = [{
  path: '/layout/spacing',
  name: 'spacing',
  label: 'Spacing',
  type: 'layout',
  component: SpacingPage,
  icon: 'web'
}, {
  path: '/layout/elevation',
  name: 'elevation',
  label: 'Elevation and shadows',
  type: 'layout',
  component: ElevationPage,
  icon: 'mdi-box-shadow'
}, {
  path: '/layout',
  name: 'top-level-layout',
  label: 'Layout',
  component: TopLevelLayout,
  type: 'layout',
  icon: 'web',
  hide: true
}, {
  path: '/components/layout',
  name: 'layout-components',
  label: 'Grid layout',
  component: LayoutPage,
  type: 'layout',
  icon: 'web'
}]

const directives = [{
  path: '/directives',
  name: 'top-level-directives',
  label: 'Directives',
  component: TopLevelDirectives,
  type: 'directives',
  icon: 'functions',
  hide: true
}, {
  path: '/directives/ripple',
  name: 'ripple',
  label: 'Ripple',
  type: 'directives',
  component: RipplePage,
  icon: 'blur_on'
}, {
  path: '/directives/tooltip',
  name: 'tooltip',
  label: 'Tooltip',
  type: 'directives',
  component: TooltipPage,
  icon: 'speaker_notes'
}, {
  path: '/directives/resize',
  name: 'resize',
  label: 'Resize',
  type: 'directives',
  component: ResizePage,
  icon: 'mdi-move-resize'
}]

const gettingStarted = [{
  path: '/getting-started',
  name: 'getting-started',
  label: 'Getting Started',
  type: 'getting-started',
  component: TopLevelGettingStarted,
  icon: 'hourglass_empty',
  hide: true
}, {
  path: '/getting-started/quick-start',
  name: 'quick-start',
  label: 'Quick start',
  type: 'getting-started',
  component: QuickStartPage,
  icon: 'mdi-speedometer'
}, {
  path: '/getting-started/browser-support',
  name: 'browser-support',
  label: 'Browser support',
  type: 'getting-started',
  component: BrowserSupportPage,
  icon: 'fa-chrome'
}, {
  path: '/getting-started/sponsors',
  name: 'sponsors',
  label: 'Sponsors',
  type: 'getting-started',
  component: SponsorsPage,
  icon: 'mdi-shield'
}, {
  path: '/getting-started/support-vuecidity',
  name: 'support-vuecidity',
  label: 'Support Vuecidity',
  type: 'getting-started',
  component: SupportVuecidityPage,
  icon: 'fa-dollar'
}, {
  path: '/getting-started/coming-up',
  name: 'coming-up',
  label: 'Coming up...',
  type: 'getting-started',
  component: ComingUpPage,
  icon: 'hourglass_empty'
}]

routes = routes
  .concat(components)
  .concat(style)
  .concat(layout)
  .concat(formElements)
  .concat(directives)
  .concat(gettingStarted)

const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  }
})

Vue.use(VueAnalytics, {
  id: Config.googleAnalyticsTrackingId,
  router
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js